export type RecurrenceFrequency = 'daily' | 'weekly' | 'monthly' | 'yearly';

export const CLOSED_TASK_STATUSES = ['Cancelled', 'Completed', 'NotDone'] as const;

export const TASK_IMPORTANCES = ['low', 'medium', 'high'] as const;

export type TaskImportance = typeof TASK_IMPORTANCES[number];

export const isClosedTaskStatus = (status?: string) => (
  !!status && (CLOSED_TASK_STATUSES as readonly string[]).includes(status)
);

export const isOpenTaskStatus = (status?: string) => !isClosedTaskStatus(status);

export interface RecurrenceRule {
  count?: number;
  dayOfMonth?: number;
  daysOfWeek?: number[];
  endDate?: Date | string;
  frequency: RecurrenceFrequency;
  interval: number;
  weekdayNth?: number;
}

export interface TimeEntry {
  createdAt?: string;
  endTime: string;
  id: string;
  minutes?: number;
  note?: string;
  estimatedRemainingTime?: number | null;
  startTime?: string;
  userId?: string;
}

export interface Task {
  id?: string;
  assignee?: string | null;
  cancelledAt?: Date | string | null;
  cancelReason?: string | null;
  description: string;
  details?: string;
  dueAt?: Date | null;
  estimatedCompletionTime?: number;
  importance?: TaskImportance | null;
  isArchived?: boolean;
  parentTaskId?: string | null;
  projects?: { id: string; }[];
  recurrence?: RecurrenceRule[];
  remainingTime?: number | null;
  slug?: string;
  startAt?: Date | null;
  status?: 'Todo' | 'Doing' | 'Blocked' | 'Cancelled' | 'Completed' | 'NotDone' | 'Deleted';
  taskId?: string;
  timeEntries?: TimeEntry[];
  type: string;
}

export type TaskDateRangeFilter = {
  $gt?: string;
  $gte?: string;
  $lt?: string;
  $lte?: string;
};

export interface TaskListFilter {
  assignee?: string | Array<string | null>;
  dueAt?: string | TaskDateRangeFilter | null;
  importance?: TaskImportance | TaskImportance[] | null;
  isArchived?: boolean;
  parentTaskId?: string | null;
  projects?: string | string[];
  startAt?: string | TaskDateRangeFilter;
  status?: string | string[] | { $ne: string } | { $nin: string[] };
  type?: 'Template' | 'Instance' | Array<'Template' | 'Instance'>;
}

export interface TaskListQuery {
  filter?: TaskListFilter;
  limit?: number;
  offset?: number;
  sort?: Record<string, -1 | 1>;
}

export interface TaskListResponse {
  limit?: number;
  offset?: number;
  tasks: Task[];
  total: number;
}

export const TASK_LIST_PAGE_SIZE = 50;
